import React, { useEffect, useState } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import { pushGtmValues } from "@bappweb/utils"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import Notes from "./notes"
import Campaign from "./campaign"
import SssList from "./ssslist"
import { useGetConfigMutation } from "../../../api/services"
import { getCidParameter } from "@smpu-web/utils/utils"

const Landing = () => {
    const [getConfig] = useGetConfigMutation();
    let cidParameter = getCidParameter();
    const [oranTable, setOranTable] = useState(true);
    useEffect(() => {
        let cidParameter = getCidParameter();
        if (cidParameter != null) {
            getConfig(`PosLead.Landing.Seo.Faq.${cidParameter}`)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError && payload.configValue) {
                        const faqElement = document.createElement("script")
                        faqElement.type = "application/ld+json"
                        faqElement.textContent = payload.configValue
                        document.head.appendChild(faqElement)
                    }
                    else {
                        getConfig("PosLead.Landing.Seo.Faq")
                            .unwrap()
                            .then((payload) => {
                                if (!payload.IsError && payload.configValue) {
                                    const faqElement = document.createElement("script")
                                    faqElement.type = "application/ld+json"
                                    faqElement.textContent = payload.configValue
                                    document.head.appendChild(faqElement)
                                }
                            })
                    }
                })
        }
        else {
            getConfig("PosLead.Landing.Seo.Faq")
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError) {
                        const faqElement = document.createElement("script")
                        faqElement.type = "application/ld+json"
                        faqElement.textContent = payload.configValue
                        document.head.appendChild(faqElement)
                    }
                })
        }

    }, [getConfig])

    useEffect(() => {
        pushGtmValues({
            event: "virtual_page_view",
            content_group: "pos-lead",
            pageName: 'basvuru/poslead/0/landing',
            pageTitle: 'Pos Lead Başvurusu'
        })
    }, []);
    
    useEffect(() => {
        if (cidParameter != null) {
            getConfig(`PosLead.Campaign.Table.Flag.${cidParameter}`)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError && payload.configValue != null) {
                        setOranTable(payload.configValue == "E" ? true : false);
                    }
                })
        }

    }, [getConfig])


    return (
        <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
            <LandingHeader />
            <Grid type="main" className="landing-page-main">
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <MainForm />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <Notes />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                        <SssList />
                    </Col>
                </Row>
                {oranTable &&
                    <Row>
                        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                            <Campaign />
                        </Col>
                    </Row>
                }

            </Grid>
        </Block>
    )
}

export default Landing
